import {materialCloudServicesPath} from "../../../Constants";
import axios from "axios";

const restUrl = materialCloudServicesPath + '/admin/manufacturers'

export default class AdminManufacturerService {
    static async get() {
        return axios.get(restUrl, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }
    static async update(data) {
        return await axios.post(restUrl + '/' + data.id, JSON.stringify(data), {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async save(data) {
        return await axios.post(restUrl, JSON.stringify(data), {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async delete(id) {
        await axios.delete(restUrl + '/' + id);
    }
}